// VendedoresMinoristas/AsignarLicenciasMinorista.jsx
export default function AsignarLicenciasMinorista() {
  return <div>Vista: Asignar Licencias</div>;
}
